const BASE_URL = process.env.REACT_APP_BASE_URL;


export const endpoints = {
  // AUTH ENDPOINTS
  SIGNUP_API: `${BASE_URL}/api/auth/signup`,
  LOGIN_API: `${BASE_URL}/api/auth/login`,

    // EVENT ENDPOINTS
    CREATE_EVENT_API: `${BASE_URL}/api/events`, // POST: Create an Event
    GET_ALL_EVENTS_API: `${BASE_URL}/api/events`, // GET: Get all Events
    GET_EVENT_BY_ID_API: (eventId) => `${BASE_URL}/api/events/${eventId}`, // GET: Get Event by ID
    UPDATE_EVENT_API: (eventId) => `${BASE_URL}/api/events/${eventId}`, // PUT: Update Event by ID
    DELETE_EVENT_API: (eventId) => `${BASE_URL}/api/events/${eventId}`, // DELETE: Delete Event by ID
    ATTEND_EVENT_API: (eventId) => `${BASE_URL}/api/events/${eventId}/attend`,
    LEAVE_EVENT_API: (eventId) => `${BASE_URL}/api/events/${eventId}/leave`,
};
